











 















const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DashboardAvatar_teamMember",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamMemberAvatarMenu_teamMember"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LeaveTeamModal_teamMember"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PromoteTeamMemberModal_teamMember"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RemoveTeamMemberModal_teamMember"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "picture",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "preferredName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isConnected",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TeamMember",
  "abstractKey": null
};

(node ).hash = "dcf1579184d8ebb4cf8700f465edc6a4";

export default node;
